<template>
  <section class="opportunity">
      <div class="opportunity__content container">
				<div class="opportunity__info-container">
					<img class="opportunity__side-img --fade-in-right --delay-1" data-vertical-ivp-class="--animate" src="../assets/opportunity/skincare-img.png" alt="Skincare picture">
					<div class="opportunity__description --fade-in-left --delay-1" data-vertical-ivp-class="--animate">
						<h2 class="opportunity__title">A Diversified Opportunity</h2>
						<div class="opportunity__lines">
							<hr class="line-1">
							<hr class="line-2">
						</div>
						<p>
						Skincare products comprise a massive piece of the health and wellness pie, 
						accounting for $213 billion globally by 2028 and registering a CAGR of 9.2%, 
						according to Grandview Research.
						</p>
						<p>
						The total Global Cannabidiol (CBD) Market is estimated to reach 
						USD 47.22 Billion by 2028, up from USD 4.9 Billion in 2021, 
						at a compound annual growth rate (CAGR) of 21.3%.
						</p>
						<p>
						The nutraceuticals market was reportedly worth $224 billion back in 2021 
						and expected to reach $365 billion by 2026 thanks to its CAGR of 10.23%.
						</p>
						<p>
						Onassis holds growing businesses in each category, positioning 
						it for future success, given current trends.
						</p>
						<a class="primary-button" href="#">SIGN UP FOR UPDATES</a>
					</div>
				</div>
      </div>
  </section>
</template>

<script>
export default {
  name: 'Opportunity',
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/opportunity.scss";
</style>
